import { createSelector } from 'reselect';
import { initalState as globalState } from '../reducers/Login/reducer';
import { initialState as appInititalState } from '../reducers/App/reducer';

const selectGlobal = (state: any) => state.global || globalState;
const selectApp = (state: any) => state.App;

export const makeSelectGlobal = () =>
  createSelector([selectGlobal], global => global);

export const getLoading = () =>
  createSelector([selectGlobal], global => global.loading || false);

export const getCurrentUser = () =>
  createSelector(
    [selectGlobal],
    global => global.currentUser || globalState.currentUser
  );

export const getLoginError = () =>
  createSelector([selectGlobal], global => global.error || globalState.error);

export const getUserData = () =>
  createSelector(
    [selectGlobal],
    global => global.userData || globalState.userData
  );

export const getShowPermissionAlert = () =>
  createSelector(
    [selectGlobal],
    global => global.showPermissionAlert || globalState.showPermissionAlert
  );

export const getPermissionAlertMessage = () =>
  createSelector(
    [selectGlobal],
    global =>
      global.permissionAlertMessage || globalState.permissionAlertMessage
  );

export const getPermissionAlertTitle = () =>
  createSelector(
    [selectGlobal],
    global => global.permissionAlertTitle || globalState.permissionAlertTitle
  );
export const makeDriverAssign = () =>
  createSelector([selectGlobal], global => global.Hidden || globalState.Hidden);

export const getGPSDetails = () =>
  createSelector([selectApp], App => App.GPSData || appInititalState.GPSData);

export const getNavUrl = () =>
  createSelector([selectApp], App => App.navigation || appInititalState.navigation);

export const getStofKey = () =>
  createSelector([selectApp], App => App.STOF_KEY || appInititalState.STOF_KEY);

export const getPlatform = () =>
  createSelector(
    [selectGlobal],
    global => global.deviceInfo.platform || globalState.deviceInfo
  );

export const getLoginToken = () =>
  createSelector([selectGlobal], global => {
    return global.loginToken || globalState.loginToken;
  });

export const getDeepLinkURI = () =>
  createSelector([selectGlobal], global => {
    return global.deepLinkURI || globalState.deepLinkURI;
  });

export const getSession = () =>
  createSelector([selectGlobal], global => {
    return global.hasSession;
  });
export const getUserDetails = () =>
  createSelector(
    [selectApp],
    user => user && user.UserDetails
  );
  export const getUserMasterData = () =>
  createSelector(
    [selectApp],
    user => user && user.UserDetailsNew
  );

export const getDeviceRegistrationResult = () =>
  createSelector(
    [selectApp],
    appState =>
      (appState && appState.deviceRegistration) ||
      appInititalState.deviceRegistration
  );

export const getRefreshStatus = () =>
  createSelector(
    [selectGlobal],
    global => global.showPullToRefresh || globalState.showPullToRefresh
  );

export const getNetworkStatus = () =>
  createSelector(
    [selectGlobal],
    global =>
      global.networkStatus.connected || globalState.networkStatus.connected
  );

export const getShowAlert = () =>
  createSelector(
    [selectApp],
    App => App.showAlert || appInititalState.showAlert
  );

export const getAlertMessage = () =>
  createSelector(
    [selectApp],
    App => App.alertMessage || appInititalState.alertMessage
  );

export const getAlertTitle = () =>
  createSelector(
    [selectApp],
    App => App.alertTitle || appInititalState.alertTitle
  );

export const getMoreContent = () =>
  createSelector(
    [selectApp],
    App => App.moreContent || appInititalState.moreContent
  );

export const getHomeWebContent = () =>
  createSelector(
    [selectApp],
    App => App.homeWebContent || appInititalState.homeWebContent
  );

export const getOfflineData = () =>
  createSelector(
    [selectApp],
    App => App.offlineJSON || appInititalState.offlineJSON
  );
export const getConfigParams = () =>
  createSelector(
    [selectApp],
    App => App.configParams || appInititalState.configParams
  );
export const getSearchParams = () =>
  createSelector(
    [selectApp],
    App => App.searchParams || appInititalState.searchParams
  );
export const getShipmentParams = () =>
  createSelector(
    [selectApp],
    App => App.shipmentParams || appInititalState.shipmentParams
  );
export const getPullToRefreshState = () =>
  createSelector(
    [selectApp],
    App => App.pullToRefreshState || appInititalState.pullToRefreshState
  );
export const getRegisterUserStatusMessage = () =>
  createSelector(selectApp, userData => {
    return userData && userData.registerUserStatusMessage;
  });
export const getNotificationData = () =>
  createSelector([selectGlobal], global => {
    return global.notificationData || globalState.notificationData;
  });
export const getSearchedLoadDataByReferenceId = () =>
  createSelector(
    [selectApp],
    App => App.searchedLoadByReferenceId || appInititalState.searchedLoadByReferenceId
  );

export const getViewSettings = () =>
  createSelector(
    selectGlobal,
    (userData) =>
      userData.userPreferences && userData.userPreferences.find((x: { key: string; }) => x.key === "viewsettings") || {}
  );
export const isCapacitor = () =>
  createSelector(
    [selectApp],
    App => App.isCapacitor || appInititalState.isCapacitor
  );

  export const getTabName = () =>
    createSelector(
      [selectApp],
      App => App.tab_name || appInititalState.tab_name
    );

export const isNotificationClosed = () =>
  createSelector(
    [selectApp],
    App => App.isNotificationClosed || appInititalState.isNotificationClosed
  );

export const isContentStackApiCalled = () =>
  createSelector(
    [selectApp],
    App => App.isContentStackApiCalled || appInititalState.isContentStackApiCalled
  );

export const getWebNotificationsData = () =>
  createSelector(
    [selectApp],
    App => App.webNotificationData || appInititalState.webNotificationData
  );

export const getNotificationBellIconState = () =>
  createSelector(
    [selectApp],
    App => App.notificationBellIconState || appInititalState.notificationBellIconState
  );

export const getParamsDict = () =>  createSelector(
  [selectApp],
  App => App.paramsDict || appInititalState.paramsDict
);

export const getSearchRefDeepLink = () =>  createSelector(
  [selectApp],
  App => App.deepLinkURI || appInititalState.deepLinkURI
);
export const PreferenceCapacityTypeSelector = () =>
createSelector([selectGlobal], global  => {
  return global && global.userPreferences;
});